import { Menu, MenuItem } from "@jugl-web/ui-components/cross-platform/Menu";
import { Button } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import React, { useMemo } from "react";
import { ReactComponent as ArrowIcon } from "../../assets/arrow.svg";

export type MethodSelectItem = { name: string; value: string };

type MethodSelectMenuProps = {
  methodItems: MethodSelectItem[];
  value: string;
  onSelect: (next: string) => void;
};

export const MethodSelectMenu: React.FC<MethodSelectMenuProps> = ({
  methodItems,
  value,
  onSelect,
}) => {
  const { t } = useTranslations();

  const menuSections = useMemo(
    () =>
      [
        methodItems.map<MenuItem>((item) => ({
          id: item.value,
          label: item.name,
          isSelected: item.value === value,
          labelClassName: "text-base text-dark px-2 py-2.5 truncate",
          onSelect: () => onSelect(item.value),
        })),
      ] as MenuItem[][],
    [methodItems, value, onSelect]
  );

  const selectedName = useMemo(
    () => methodItems.find((item) => item.value === value)?.name ?? value,
    [methodItems, value]
  );

  return (
    <Menu
      placement="bottom-end"
      adjustToTriggerWidth
      sections={menuSections}
      autoClose
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          ref={triggerRef}
          as={Button}
          variant="secondary"
          size="sm"
          iconEnd={
            <ArrowIcon
              className={cx("transition-transform", isOpen && "rotate-180")}
            />
          }
        >
          <span className="truncate">
            {t({
              id: "common.method",
              defaultMessage: "Method",
            })}
            : {selectedName}
          </span>
        </Trigger>
      )}
    />
  );
};
